import utilsFunction from "../../../utils/utilsFunction";
import { v4 as uuidV4 } from "uuid";
import { toast } from "react-toastify";

export const addToTableData = ({ object, setData, data }) => {
  let tableData = [...data.tableData];

  const objectFound = tableData.find((v) => +v.productId === +object.productId);
  if (objectFound) {
    // tableData.forEach(v => {
    //   if (+v.productId === +object.productId) {
    //     v.number = +v.number + 1
    //   }
    // })
    // گفته شد که  اگه کالای تکراری وارد کرد نباید اصلا وارد جدول کنی
    toast.info("این کالا به جدول اضافه شده است");
  } else {
    object.uniqId = uuidV4();
    object.mustICalculateTotalWeight = true;
    // For بسته products, auto-calculate totalWeight from weight × number
    // For فله products, user must enter totalWeight manually
    if (object.productType === "بسته") {
      object.totalWeight = String(
        parseFloat(object.weight || 0) * parseInt(object.number || 1),
      );
    } else {
      object.totalWeight = "";
    }
    object.recordId = "";
    tableData.push(object);
    tableData = utilsFunction.addRowIdToTable(tableData);
    tableData = calculateSumOfRowOrderSadan(tableData);
  }
  setData({ tableData });
};

export const deleteRowHandleOrderSadan = ({ uniqId, data, setData }) => {
  const temp = [...data.tableData];
  const tableData = temp.filter((ob) => ob.uniqId !== uniqId);
  const newTable = utilsFunction.addRowIdToTable(tableData);
  setData({ tableData: newTable });
};

export const updateTableDataOrderSadan = ({
  uniqId,
  value,
  field,
  data,
  setData,
}) => {
  let tableData = [...data.tableData];
  tableData.forEach((row) => {
    if (row.uniqId === uniqId) {
      row[field] = value;
    }
  });

  tableData = calculateSumOfRowOrderSadan(tableData);
  setData({ tableData });
};

export const calculateSumOfRowOrderSadan = (tb) => {
  const tableData = [...tb];
  tableData.forEach((row) => {
    const temp = 1 - row.discount / 100;

    if (row.productType === "بسته") {
      // Only auto-calculate if user hasn't manually overridden
      if (row.mustICalculateTotalWeight === true || row.mustICalculateTotalWeight === "1") {
        row.totalWeight = String(
          parseFloat(
            (parseFloat(row.weight || 0) * parseInt(row.number || 1)).toFixed(3),
          ),
        );
      }
    }

    // For ALL products, price is per KG, so sum is based on totalWeight
    const weightForCalc = parseFloat(row.totalWeight) || 0;
    row.sum = +row.price * +temp * weightForCalc;

    row.sum = row.sum.toFixed();
  });

  return tableData;
};
